import { render } from "./Music.vue?vue&type=template&id=34d33dd6&scoped=true"
import script from "./Music.vue?vue&type=script&lang=js"
export * from "./Music.vue?vue&type=script&lang=js"

import "./Music.vue?vue&type=style&index=0&id=34d33dd6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\PC\\Documents\\vue.js\\marvel\\marvel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34d33dd6"]])

export default __exports__